class ChillShipping {
  constructor() {
    this.attributeKey = 'chill_shipping_province';
    this.storageKey = 'chill_shipping_province';

    this.totalCans = 0;
    this.province = '';

    this.syncingProvince = false;
    this.refreshTimer = null;
    this.cartObserver = null;

    this.rates = {
      PE: {
        name: 'Prince Edward Island',
        tiers: [15, 20, 20],
      },

      NS: {
        name: 'Nova Scotia',
        tiers: [10, 0, 15],
      },

      NB: {
        name: 'New Brunswick',
        tiers: [20, 25, 25],
      },

      NL: {
        name: 'Newfoundland & Labrador',
        tiers: [20, 25, 30],
      },

      ON: {
        name: 'Ontario',
        tiers: [18, 25, 30],
      },

      MB: {
        name: 'Manitoba',
        tiers: [25, 32, 35],
      },

      SK: {
        name: 'Saskatchewan',
        tiers: [25, 32, 35],
      },

      AB: {
        name: 'Alberta',
        tiers: [25, 32, 35],
      },

      BC: {
        name: 'British Columbia',
        tiers: [28, 34, 40],
      },

      QC: {
        name: 'Quebec',
        tiers: [18, 25, 30],
      },

      YT: {
        name: 'Yukon',
        tiers: [28, 34, 40],
      },

      NT: {
        name: 'Northwest Territories',
        tiers: [25, 32, 35],
      },

      NU: {
        name: 'Nunavut',
        tiers: [25, 32, 35],
      },
    };
  }

  init() {
    this.bindProvinceSelectors();

    window.addEventListener(
      'chill:total-cans-updated',
      (event) => {
        const totalCans = Number(
          event.detail?.totalCans || 0
        );

        if (
          Number.isFinite(totalCans) &&
          totalCans >= 0
        ) {
          this.totalCans = totalCans;
        }

        this.restoreProvince()
          .then(() => {
            this.syncSelectors();
            this.render();
          })
          .catch((error) => {
            console.error(
              '[Chill Shipping Restore]',
              error
            );
          });
      }
    );

    document.addEventListener(
      'change',
      (event) => {
        const select =
          event.target.closest(
            '[data-chill-province]'
          );

        if (!select) {
          return;
        }

        this.setProvince(
          select.value
        );
      }
    );

    document.addEventListener(
      'chill:shipping-refresh',
      () => {
        this.scheduleRefresh(50);
      }
    );

    document.addEventListener(
      'cart:updated',
      () => {
        this.scheduleRefresh(100);
      }
    );

    document.addEventListener(
      'shopify:section:load',
      () => {
        this.scheduleRefresh(100);
      }
    );

    window.addEventListener(
      'pageshow',
      () => {
        this.scheduleRefresh(50);
      }
    );

    window.addEventListener(
      'focus',
      () => {
        this.scheduleRefresh(100);
      }
    );

    this.observeCartChanges();

    this.refresh();

    setTimeout(() => {
      this.refresh();
    }, 600);

    setTimeout(() => {
      this.refresh();
    }, 1200);

    setTimeout(() => {
      this.refresh();
    }, 2000);
  }

  bindProvinceSelectors() {
    document
      .querySelectorAll(
        '[data-chill-province]'
      )
      .forEach((select) => {
        if (
          this.province &&
          this.rates[this.province] &&
          select.value !==
            this.province
        ) {
          select.value =
            this.province;
        }
      });
  }

  scheduleRefresh(delay = 120) {
    if (this.refreshTimer) {
      clearTimeout(
        this.refreshTimer
      );
    }

    this.refreshTimer =
      setTimeout(() => {
        this.refresh();
      }, delay);
  }

  observeCartChanges() {
    if (
      !document.body ||
      typeof MutationObserver ===
        'undefined'
    ) {
      return;
    }

    if (this.cartObserver) {
      this.cartObserver.disconnect();
    }

    this.cartObserver =
      new MutationObserver(
        (mutations) => {
          let shouldRefresh =
            false;

          for (
            const mutation
            of mutations
          ) {
            if (
              mutation.type !==
              'childList'
            ) {
              continue;
            }

            for (
              const node
              of mutation.addedNodes
            ) {
              if (
                node.nodeType !==
                Node.ELEMENT_NODE
              ) {
                continue;
              }

              if (
                node.matches?.(
                  '[data-chill-province]'
                ) ||
                node.matches?.(
                  '[data-chill-shipping-value]'
                ) ||
                node.matches?.(
                  '[data-chill-shipping-cans]'
                ) ||
                node.matches?.(
                  '[data-chill-cart-line]'
                ) ||
                node.querySelector?.(
                  '[data-chill-province]'
                ) ||
                node.querySelector?.(
                  '[data-chill-shipping-value]'
                ) ||
                node.querySelector?.(
                  '[data-chill-cart-line]'
                )
              ) {
                shouldRefresh =
                  true;

                break;
              }
            }

            if (shouldRefresh) {
              break;
            }
          }

          if (shouldRefresh) {
            this.scheduleRefresh(
              100
            );
          }
        }
      );

    this.cartObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true,
      }
    );
  }

  async refresh() {
    try {
      await this.restoreProvince();

      const totalCans =
        await this.getTotalCans();

      this.totalCans =
        Number.isFinite(
          totalCans
        )
          ? totalCans
          : 0;

      this.bindProvinceSelectors();
      this.syncSelectors();
      this.render();
    } catch (error) {
      console.error(
        '[Chill Shipping]',
        error
      );
    }
  }

  getProvinceFromDOM() {
    const select =
      document.querySelector(
        '[data-chill-province]'
      );

    if (!select) {
      return '';
    }

    const province =
      String(
        select.value || ''
      ).trim();

    if (
      province &&
      this.rates[province]
    ) {
      return province;
    }

    return '';
  }

  getSavedProvince() {
    try {
      const province =
        String(
          localStorage.getItem(
            this.storageKey
          ) || ''
        ).trim();

      if (
        province &&
        this.rates[province]
      ) {
        return province;
      }
    } catch (error) {
      console.warn(
        '[Chill Shipping] Unable to read local province.',
        error
      );
    }

    return '';
  }

  saveProvinceLocal(
    province
  ) {
    if (
      !province ||
      !this.rates[province]
    ) {
      return;
    }

    try {
      localStorage.setItem(
        this.storageKey,
        province
      );
    } catch (error) {
      console.warn(
        '[Chill Shipping] Unable to save local province.',
        error
      );
    }
  }

  async getProvinceFromCart() {
    try {
      const cartJsonUrl =
        window.routes?.cart_url
          ? `${window.routes.cart_url}.js`
          : '/cart.js';

      const separator =
        cartJsonUrl.includes('?')
          ? '&'
          : '?';

      const response =
        await fetch(
          `${cartJsonUrl}${separator}_=${Date.now()}`,
          {
            method: 'GET',

            headers: {
              Accept:
                'application/json',
            },

            cache: 'no-store',
          }
        );

      if (!response.ok) {
        return '';
      }

      const cart =
        await response.json();

      const province =
        String(
          cart?.attributes?.[
            this.attributeKey
          ] || ''
        ).trim();

      if (
        province &&
        this.rates[province]
      ) {
        return province;
      }
    } catch (error) {
      console.warn(
        '[Chill Shipping] Unable to restore province from cart.',
        error
      );
    }

    return '';
  }

  async restoreProvince() {
    if (
      this.province &&
      this.rates[
        this.province
      ]
    ) {
      return this.province;
    }

    const localProvince =
      this.getSavedProvince();

    if (localProvince) {
      this.province =
        localProvince;

      return this.province;
    }

    const cartProvince =
      await this.getProvinceFromCart();

    if (cartProvince) {
      this.province =
        cartProvince;

      this.saveProvinceLocal(
        cartProvince
      );

      return this.province;
    }

    const domProvince =
      this.getProvinceFromDOM();

    if (domProvince) {
      this.province =
        domProvince;

      this.saveProvinceLocal(
        domProvince
      );

      return this.province;
    }

    this.province = '';

    return '';
  }

  async getTotalCans() {
    const datasetValue =
      Number(
        document.documentElement
          .dataset
          .chillTotalCans
      );

    if (
      Number.isFinite(
        datasetValue
      ) &&
      datasetValue > 0
    ) {
      return datasetValue;
    }

    const cartUrl =
      window.routes?.cart_url ||
      '/cart';

    const separator =
      cartUrl.includes('?')
        ? '&'
        : '?';

    const url =
      `${cartUrl}${separator}section_id=main-cart-items&_=${Date.now()}`;

    const response =
      await fetch(url, {
        method: 'GET',

        headers: {
          Accept: 'text/html',
        },

        cache: 'no-store',
      });

    if (!response.ok) {
      throw new Error(
        'Unable to load cart can quantity.'
      );
    }

    const html =
      await response.text();

    const documentFragment =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );

    const rows =
      Array.from(
        documentFragment
          .querySelectorAll(
            '[data-chill-cart-line]'
          )
      );

    let totalCans = 0;

    rows.forEach((row) => {
      const isDeposit =
        row.dataset
          .chillDeposit ===
        'true';

      if (isDeposit) {
        return;
      }

      const cansPerUnit =
        Number(
          row.dataset
            .cansPerUnit ||
          0
        );

      const quantity =
        Number(
          row.dataset
            .quantity ||
          0
        );

      if (
        cansPerUnit > 0 &&
        quantity > 0
      ) {
        totalCans +=
          cansPerUnit *
          quantity;
      }
    });

    return totalCans;
  }

  getStandardTierIndex(
    totalCans
  ) {
    if (totalCans <= 0) {
      return -1;
    }

    if (totalCans <= 23) {
      return 0;
    }

    if (totalCans <= 47) {
      return 1;
    }

    return 2;
  }

  getStandardTierLabel(
    totalCans
  ) {
    if (totalCans <= 0) {
      return '';
    }

    if (totalCans <= 23) {
      return '1–23 cans';
    }

    if (totalCans <= 47) {
      return '24–47 cans';
    }

    return '48+ cans';
  }

  getNovaScotiaRate(
    totalCans
  ) {
    if (totalCans <= 0) {
      return null;
    }

    if (totalCans <= 11) {
      return {
        tierIndex: 0,
        tierLabel:
          '1–11 cans',
        amount: 10,
      };
    }

    if (totalCans <= 47) {
      return {
        tierIndex: 1,
        tierLabel:
          '12–47 cans',
        amount: 0,
      };
    }

    return {
      tierIndex: 2,
      tierLabel:
        '48+ cans',
      amount: 15,
    };
  }

  getShippingRate(
    province,
    totalCans
  ) {
    if (
      !province ||
      !this.rates[province] ||
      totalCans <= 0
    ) {
      return null;
    }

    const provinceData =
      this.rates[
        province
      ];

    if (
      province === 'NS'
    ) {
      const novaScotiaRate =
        this.getNovaScotiaRate(
          totalCans
        );

      if (
        !novaScotiaRate
      ) {
        return null;
      }

      return {
        province,

        provinceName:
          provinceData.name,

        tierIndex:
          novaScotiaRate
            .tierIndex,

        tierLabel:
          novaScotiaRate
            .tierLabel,

        amount:
          novaScotiaRate
            .amount,

        totalCans,
      };
    }

    const tierIndex =
      this.getStandardTierIndex(
        totalCans
      );

    if (tierIndex < 0) {
      return null;
    }

    return {
      province,

      provinceName:
        provinceData.name,

      tierIndex,

      tierLabel:
        this.getStandardTierLabel(
          totalCans
        ),

      amount:
        provinceData
          .tiers[
            tierIndex
          ],

      totalCans,
    };
  }

  getTierLabel(
    province,
    totalCans
  ) {
    if (totalCans <= 0) {
      return '';
    }

    if (
      province === 'NS'
    ) {
      if (
        totalCans <= 11
      ) {
        return '1–11 cans';
      }

      if (
        totalCans <= 47
      ) {
        return '12–47 cans';
      }

      return '48+ cans';
    }

    return this
      .getStandardTierLabel(
        totalCans
      );
  }

  formatMoney(amount) {
    if (
      Number(amount) === 0
    ) {
      return 'FREE';
    }

    return `$${Number(
      amount
    ).toFixed(2)} CAD`;
  }

  async setProvince(
    province
  ) {
    province =
      String(
        province || ''
      ).trim();

    if (
      !province ||
      !this.rates[
        province
      ]
    ) {
      return;
    }

    this.province =
      province;

    this.saveProvinceLocal(
      province
    );

    this.syncSelectors();
    this.render();

    if (
      this.syncingProvince
    ) {
      return;
    }

    this.syncingProvince =
      true;

    try {
      await this
        .saveProvinceToCart(
          province
        );
    } catch (error) {
      console.error(
        '[Chill Shipping Province]',
        error
      );
    } finally {
      this.syncingProvince =
        false;
    }
  }

  async saveProvinceToCart(
    province
  ) {
    const updateUrl =
      window.routes
        ?.cart_update_url ||
      '/cart/update.js';

    const response =
      await fetch(
        updateUrl,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json',
          },

          body:
            JSON.stringify({
              attributes: {
                [this.attributeKey]:
                  province,
              },
            }),
        }
      );

    if (!response.ok) {
      throw new Error(
        'Unable to save shipping province.'
      );
    }

    const cart =
      await response.json();

    return cart;
  }

  syncSelectors() {
    if (
      !this.province ||
      !this.rates[
        this.province
      ]
    ) {
      return;
    }

    document
      .querySelectorAll(
        '[data-chill-province]'
      )
      .forEach(
        (select) => {
          if (
            select.value !==
            this.province
          ) {
            select.value =
              this.province;
          }
        }
      );
  }

  render() {
    const rate =
      this.getShippingRate(
        this.province,
        this.totalCans
      );

    const tierLabel =
      rate?.tierLabel ||
      this.getTierLabel(
        this.province,
        this.totalCans
      );

    document
      .querySelectorAll(
        '[data-chill-shipping-cans]'
      )
      .forEach(
        (element) => {
          if (
            this.totalCans === 1
          ) {
            element.textContent =
              '1 can';

            return;
          }

          element.textContent =
            `${this.totalCans} cans`;
        }
      );

    document
      .querySelectorAll(
        '[data-chill-shipping-tier]'
      )
      .forEach(
        (element) => {
          element.textContent =
            tierLabel || '';
        }
      );

    document
      .querySelectorAll(
        '[data-chill-shipping-value]'
      )
      .forEach(
        (element) => {
          if (
            !this.province
          ) {
            element.textContent =
              'Select province';

            return;
          }

          if (!rate) {
            element.textContent =
              'Calculated at checkout';

            return;
          }

          element.textContent =
            this.formatMoney(
              rate.amount
            );
        }
      );

    document
      .querySelectorAll(
        '[data-chill-shipping-detail]'
      )
      .forEach(
        (element) => {
          if (
            !this.province
          ) {
            element.textContent =
              'Choose your province to estimate shipping.';

            return;
          }

          if (!rate) {
            element.textContent =
              '';

            return;
          }

          if (
            rate.amount === 0
          ) {
            element.textContent =
              `${rate.provinceName} · ${tierLabel} · Free shipping`;

            return;
          }

          element.textContent =
            `${rate.provinceName} · ${tierLabel} · ${this.formatMoney(
              rate.amount
            )} shipping`;
        }
      );

    document
      .documentElement
      .dataset
      .chillShippingProvince =
      this.province || '';

    document
      .documentElement
      .dataset
      .chillShippingAmount =
      rate
        ? String(
            rate.amount
          )
        : '';

    window.dispatchEvent(
      new CustomEvent(
        'chill:shipping-updated',
        {
          detail: {
            province:
              this.province,

            totalCans:
              this.totalCans,

            rate,
          },
        }
      )
    );
  }
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    if (
      window.chillShipping
    ) {
      window.chillShipping
        .scheduleRefresh?.(
          50
        );

      return;
    }

    window.chillShipping =
      new ChillShipping();

    window.chillShipping.init();
  }
);